import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SoftwareService } from '../../../../../../admin/src/app/services/software.service';
import { Software } from '../../../../../../admin/src/app/models/software';
import { MatomoTracker } from 'ngx-matomo';

@Component({
  selector: 'app-product-software',
  templateUrl: './product-software.component.html',
  styleUrls: ['./product-software.component.css']
})
export class ProductSoftwareComponent implements OnInit, OnDestroy {

  productId: string;

  softwares: Software[];

  sub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private softwareSvc: SoftwareService,
    private translate: TranslateService,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit() {
    this.matomoTracker.trackPageView('Product software');

    this.sub = this.route.parent.paramMap.subscribe(params => {
      this.productId = params.get('productId');
      this.getSoftwares();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getSoftwares() {
    this.softwareSvc.getAll(this.productId).subscribe(data => {
      let lang = this.translate.currentLang;
      this.softwares = Object.assign([], data.payload.elements);
      this.softwares.sort((i1, i2) => {
        return i1.name.toLowerCase() < i2.name.toLowerCase() ? -1 : 1;
      });
    });
  }

}
